<svg width="12" height="12" fill="none" viewBox="0 0 12 12" id="close" x="1897" y="1059"
  xmlns="http://www.w3.org/2000/svg">
  <path class="stroke-navy-70" d="M1 1l10 10M1 11L11 1" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
  </path>
</svg>
